"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Row = _interopRequireDefault(require("../Row"));

var _Header = _interopRequireDefault(require("../Header"));

var _Column = _interopRequireDefault(require("../Column"));

var _classnames = _interopRequireDefault(require("classnames"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function Table(_ref) {
  var _data = _ref._data,
      empty = _ref.empty,
      columns = _ref.columns,
      children = _ref.children,
      className = _ref.className;
  var tableClassName = (0, _classnames["default"])(_defaultModule["default"]['wrapper'], className);

  try {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: tableClassName
    }, /*#__PURE__*/_react["default"].createElement("table", {
      className: _defaultModule["default"]['table'],
      "data-locator": _data
    }, /*#__PURE__*/_react["default"].createElement(_Header["default"], {
      _data: _data
    }, children), !columns.length && /*#__PURE__*/_react["default"].createElement("caption", {
      "data-locator": _data ? "".concat(_data, ".empty") : 'empty',
      className: _defaultModule["default"]['table__empty']
    }, empty), columns.map(function (item, index) {
      return /*#__PURE__*/_react["default"].createElement(_Row["default"], {
        _data: _data ? "".concat(_data, ".row[").concat(index, "]") : "row[".concat(index, "]"),
        key: index,
        data: item
      }, _react["default"].Children.map(children, function (Child) {
        if (!Child) {
          return null;
        }

        return /*#__PURE__*/_react["default"].cloneElement(Child, {
          _parent: _data
        });
      }));
    })));
  } catch (e) {
    throw e;
  }
}

Table.defaultProps = {
  empty: 'Нет данных для отображения',
  columns: [],
  children: _Column["default"],
  className: ''
};
var _default = Table;
exports["default"] = _default;